<!-- 采购 -->
<template>
<span>
    <el-dialog
        :title="msg('采购')"
        :visible.sync="visible"
        :close-on-click-modal="false"
        size="mini"
        width="65%"
        @closed="closeDg"
    >
        <el-form ref="form" label-width="100px">
            <el-form-item :label="msg('采购链接：')">
                <el-input v-model="purchaseLink" :placeholder="msg('请输入采购链接')"></el-input>
            </el-form-item>
            <el-form-item :label="msg('货物类型：')">
                <el-select v-model="productType" clearable :placeholder="msg('请选择货物类型')">
                    <el-option v-for="d in stockExpGoodType" 
                        :label="d.label" :value="d.value" :key="d.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <div>
                    <el-checkbox size="medium" v-model="useSameLink">
                        <span>
                            同一商品ID不同规格统一使用同一采购链接<span style="color:red;">（只在选中一个商品详情时生效）</span>
                        </span>
                    </el-checkbox>
                </div>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">{{msg('取消')}}</el-button>
            <el-button type="primary" @click="doBuy()">{{!checked?msg('采购'):msg("确定")}}</el-button>
        </span>
    </el-dialog>
</span>    
</template>

<script>
import OrderService from './OrderService.js';
export default {
    name: "BuyDialog",
    mounted(){
        let temps = this.dicts.stockExpGoodType;
        this.stockExpGoodType = temps.filter(s => s.value>1);
        this.user  = JSON.parse(localStorage.getItem("user"));
    },
    data(){
        return {
            visible: false,
            purchaseLink: null,
            selectes: null,
            detail: null,
            
            productType: null,
            stockExpGoodType: [],
            useSameLink: false,   //选择单条的时候，如果勾选了，则新增一条没有规格的采购链接
            checked: false, //点击采购时，如有采购链接，直接跳转到采购网址，如没有采购链接的，则再弹出链接录入框
            callback: null,
            user:null,
        } 
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                return this.$store.state.isMinScreen;
            }
        },
        orderInfoWindowId: { //订单详情窗口id
            get() {
                var is = this.$store.state.orderInfoWindowId;
                return is;
            }
        },
    },
    methods: {
        //检测是否有采购链接，如果右，直接进行采购，如果没有，则先弹出输入采购链接弹窗
        //checked默认false, 需要检测链接，如果为true则不需要检测
        checkNeedBuy(detail, selectes, checked, callback){
            if(this.user.deptPath.indexOf('/1/6262/2') > -1){
                //圣捷下面的客户只需要有会员就可以
                if(!this.user.vip || this.user.vip == 0){
                    this.$message(this.msg('没有权限或非超级会员，不能进行快捷采购！'));
                    return;
                }
            }else{
                if(!this.hasPermission("stock:detailPurchase")){
                    this.$message(this.msg('没有权限或非超级会员，不能进行快捷采购！'));
                    return;
                }
            }
            // var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length == 0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
 
            this.selectes = selectes;
            this.checked = checked || false;
            this.callback = callback;
            this.detail = detail;

            let para = {
                link: this.purchaseLink || null,
                detailIds: selectes.map(d => d.id),
                stockIds:  selectes.map(d => d.stockId)
            };
            var _this = this;
            //点击采购时，如有采购链接，直接跳转到采购网址，如没有采购链接的，则再弹出链接录入框
            if(!checked){
                this.$axios.post(
                    this.$kit.api.stockDetail.openBuyLinks,
                    para
                ).then((result) => {
                    if(result.status){
                        // 使用采购链接和详情调用chrome插件进行采购
                        let link = result.data;
                        OrderService.chromeBuy(link, this.detail, null, (result)=>{
                            if(result.status){
                                if(this.callback){
                                    this.callback();
                                }
                            }
                        });
                    }else{
                        this.purchaseLink = null;
                        this.productType  = null;
                        this.useSameLink = false;
                        this.visible = true;
                    }
                    this.$message(result.msg);
                });
            }else{
                this.purchaseLink = null;
                this.productType  = null;
                this.useSameLink = false;
                this.visible = true;
            }
        },
        doBuy(){  //采购

            if(this.checked && !this.purchaseLink){
                this.$message("请输入采购链接");
                return;
            }

            let para = {
                link: this.purchaseLink || null,
                productType: this.productType || null,
                detailIds: this.selectes.map(d => d.id),
                stockIds:  this.selectes.map(d => d.stockId),
                useSameLink: this.useSameLink || false,
                checked: this.checked||false
            };
            //根据详情标题，搜索采购链接表，查找对应链接
            //如果找到，则打开新链接
            //如果没找到，则提示输入链接
            this.$axios.post(
                this.$kit.api.stockDetail.openBuyLinks,
                para
            ).then((result) => {
                if(!this.checked){
                    if(result.status){
                        this.visible = false;
                        OrderService.chromeBuy(this.purchaseLink, this.detail, null, (result)=>{
                            if(result.status){
                                if(this.callback){
                                    this.callback();
                                }
                            }
                        });

                    }else{
                        // this.$alert(this.msg('未匹配到采购链接，请自行输入链接后再次采购'), this.msg('提示'), {
                        //     confirmButtonText: this.msg('确定'),
                        // });
                        this.$message({
                            type: 'info',
                            message: result.msg?result.msg:"未匹配到采购链接，请自行输入链接后再次采购"
                        });
                    }
                }else{
                    this.visible = result.status? false: true;
                    this.$message(this.msg(result.msg));
                }
            });
        },
        closeDg(){
            this.purchaseLink = null;
        },
    }
}

</script>